<template>
  <div>
    <Row>
      <Col span="12" class="b-panel">
        <Tree :data="treeData" @on-select-change="selectData"></Tree>
      </Col>
      <Col span="12" class="b-panel">
        <Table border :columns="columns1" :data="departmentList"></Table>
      </Col>
    </Row>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      treeData: [],
      departmentList: [],
      columns1: [
        {
          title: "科室名称",
          key: "departmentName",
        },
        {
          title: "科室编号",
          key: "departmentCode",
        },
        {
          title: "操作",
          render: (h, params) => {
            return h("div", [
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: "5px",
                  },
                  on: {
                    click: () => {
                      this.selectDepartment(params.row);
                    },
                  },
                },
                "选择"
              ),
            ]);
          },
        },
      ],
    };
  },

  created: function () {
    this.getListTree();
  },

  methods: {
    //获取机构树
    getListTree() {
      var parm = { ids: [] };
      this.$api.post("/organ/getListTree",parm).then((rsp) => {
        if (rsp != false) {
          this.treeData = rsp.data;
        }
      });
    },

    //获取机构下的科室列表
    getDepartmentList(organId) {
      this.$api
        .get(`/department/getListByOrganId?organId=${organId}`)
        .then((rsp) => {
          if (rsp != false) {
            this.departmentList = rsp.data;
          }
        });
    },

    //选择机构回调
    selectData: function (data) {
        let organId=data[0].organID;
        this.getDepartmentList(organId);
    },

    selectDepartment: function (data) {
        this.$emit("selectDepartment",data);
    },
  },
};
</script>
<style scoped>
.b-panel {
  border: 1px solid #ccc;
  height: 350px;
  padding: 5px;
  overflow: auto;
}
</style>